import clsx from 'clsx'
import React from 'react'

type Props = {
  totalCount: number
  pageSize: number
  currentPage: number
  onPageChange: (page: number) => void
}

export const AncientListPagination: React.FC<Props> = ({
  totalCount,
  pageSize,
  currentPage,
  onPageChange,
}) => {
  const pagesCount = Math.ceil(totalCount / pageSize)
  if (pagesCount === 1) return null

  const pages = Array.from({length: pagesCount}, (_, i) => i + 1)

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
      <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
        <div id='kt_table_users_paginate'>
          <ul className='pagination'>
            {pages.map((page) => (
              <li
                key={page}
                className={clsx('page-item', {
                  active: currentPage === page,
                })}
              >
                <button
                  className='page-link'
                  onClick={() => onPageChange(page)}
                  style={{cursor: 'pointer'}}
                >
                  {page}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
